import {  attributeDefRowSchemaView, AttributeDefRowView, profileAttributeSchemaUI } from "@bonusmap/api-types";
import { BaseWebComponent } from "../base-components/base-web-component.js";
export abstract class ProfileBaseComponent extends BaseWebComponent {
    // questa è una classe base per i componenti web di profile
    // 
    protected onConnected(): void {
        // console.log(`connected: ${this.webComponentName}`);
    }
     protected isAttributeValid(attribute: any): attribute is AttributeDefRowView {
        const parsed = attributeDefRowSchemaView.safeParse(attribute);
        return parsed.success;
    }
    public isValidProfileAttribute(profileAttribute: any): boolean {
            const parsed = profileAttributeSchemaUI.safeParse(profileAttribute);
            return parsed.success;
        }
        public get readOnly(): boolean {
            return this.hasAttribute('readonly') ||this.closest('[readonly]')!==null;
        }
}